import { ActionTypes } from 'titus-ts/dist/js/Util/Actions/ActionTypes';
import { DictionaryInterface } from 'titus-ts/dist/js/Common/Util/DictionaryInterface';
import { MetadataObject } from 'titus-ts/dist/js/Util/Metadata/MetadataObject';

export const STORAGE_KEYS = {
    POLICY_ALERTS: 'POLICY_ALERTS',
    POLICY_SUGGEST_PREAMBLE: 'POLICY_SUGGEST_PREAMBLE',
    AUTH_TITUS_TOKEN: 'AUTH_TITUS_TOKEN',
    POLICY_DIALOG_CURRENT_METADATA: 'POLICY_DIALOG_CURRENT_METADATA',
    POLICY_DIALOG_ORIGINAL_METADATA: 'POLICY_DIALOG_ORIGINAL_METADATA',
    POLICY_OBLIGATIONS_ORIGINAL_METADATA: 'POLICY_OBLIGATIONS_ORIGINAL_METADATA',
    PERFORMANCE_TIMINGS: 'PERFORMANCE_TIMINGS',
} as const;

export type StorageKeys = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

export type SerializableAction = {
    name: string;
    type: ActionTypes;
    id: string;
    ruleId: string;
    ruleName: string;
    params: DictionaryInterface<string>;
};

export type SerializableOrignalMetadata = {
    [k: string]: MetadataObject;
};
